// UMass Lowell's bachelor's majors (#2839). Read on 2026-10-01 from the
// "Undergraduate Majors" page of UMass Lowell's online Academic Catalog
// (www.uml.edu/catalog/undergraduate/majors.aspx), the current edition (its
// Catalog Archives page lists 2025-2026 as the newest archived year, and
// says the online catalog is archived each academic year). One entry per
// listed major with the degree the list gives (52 in all); options and
// concentrations are not listed separately. Each major is grouped by the
// college whose catalog section its link leads to. The list marks American
// Studies, Digital Media, Liberal Arts and Peace & Conflict Studies as
// interdisciplinary majors. Left out: minors, post-baccalaureate
// certificates, online programs and graduate programs.
const majors = {
    "slug": "university-of-massachusetts-lowell",
    "read": "2026-10-01",
    "intro": "Every bachelor's major on UMass Lowell's official Undergraduate Majors list in its current Academic Catalog, grouped by the college that offers it, with the degree it leads to. Options, concentrations, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Fine Arts, Humanities and Social Sciences",
            "source": {
                "label": "UMass Lowell Academic Catalog, Undergraduate Majors, College of Fine Arts, Humanities and Social Sciences",
                "url": "https://www.uml.edu/catalog/undergraduate/fahss/"
            },
            "majors": [
                {
                    "name": "American Studies",
                    "degree": "B.A.",
                    "note": "Interdisciplinary major."
                },
                {
                    "name": "Art",
                    "degree": "B.F.A."
                },
                {
                    "name": "Composition for New Media",
                    "degree": "B.M."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Media",
                    "degree": "B.A.",
                    "note": "Interdisciplinary major."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "B.F.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Liberal Arts",
                    "degree": "B.L.A.",
                    "note": "Interdisciplinary major."
                },
                {
                    "name": "Music Business",
                    "degree": "B.M."
                },
                {
                    "name": "Music Performance",
                    "degree": "B.M."
                },
                {
                    "name": "Music Studies",
                    "degree": "B.M."
                },
                {
                    "name": "Peace & Conflict Studies",
                    "degree": "B.A.",
                    "note": "Interdisciplinary major."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Quantitative Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Sound Recording Technology",
                    "degree": "B.M."
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Francis College of Engineering",
            "source": {
                "label": "UMass Lowell Academic Catalog, Undergraduate Majors, Francis College of Engineering",
                "url": "https://www.uml.edu/catalog/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Electrical Engineering with additional major in Computer Science",
                    "degree": "B.S.E."
                },
                {
                    "name": "Electrical Engineering with additional major in Physics",
                    "degree": "B.S.E."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S.E."
                },
                {
                    "name": "Plastics Engineering",
                    "degree": "B.S.E."
                }
            ]
        },
        {
            "name": "Kennedy College of Sciences",
            "source": {
                "label": "UMass Lowell Academic Catalog, Undergraduate Majors, Kennedy College of Sciences",
                "url": "https://www.uml.edu/catalog/undergraduate/sciences/"
            },
            "majors": [
                {
                    "name": "Actuarial Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Artificial Intelligence and Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Mathematics and Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Climate Change and Sustainability",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Meteorology and Atmospheric Science",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Manning School of Business",
            "source": {
                "label": "UMass Lowell Academic Catalog, Undergraduate Majors, Manning School of Business",
                "url": "https://www.uml.edu/catalog/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.S.B.A.",
                    "note": "Concentrations in accounting, analytics and operations management, entrepreneurship, finance, international business, management, management information systems and marketing."
                }
            ]
        },
        {
            "name": "Zuckerberg College of Health Sciences",
            "source": {
                "label": "UMass Lowell Academic Catalog, Undergraduate Majors, Zuckerberg College of Health Sciences",
                "url": "https://www.uml.edu/catalog/undergraduate/health-sciences/"
            },
            "majors": [
                {
                    "name": "Applied Biomedical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Exercise Science",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "B.S."
                },
                {
                    "name": "Nutritional Science",
                    "degree": "B.S."
                },
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
